import Cookies from 'js-cookie'

// 🔑 动态 Cookie domain —— 生产域用根域共享（跨子系统），IP/localhost 不设 domain（仅当前主机）
const hostname = typeof window !== 'undefined' ? window.location.hostname : ''
const IS_PROD_DOMAIN = hostname.includes('jdat99.com')
// eslint-disable-next-line no-undef
const COOKIE_DOMAIN = IS_PROD_DOMAIN ? '.jdat99.com' : ''
const COOKIE_PATH = '/'

const TokenKey = 'digital-card-token'
const UserIdKey = 'digital-card-user-id'
const RememberPhoneKey = 'digital-card-remember-phone'
const RememberPasswordKey = 'digital-card-remember-password'
const PendingShareIdKey = 'digital-card-pending-share-id'   // 待绑定的推荐人 share_id（访问分享链接时捕获）
const MyShareIdKey = 'digital-card-my-share-id'             // 当前用户自己的 share_id（用于生成分享链接）

// Cookie 统一配置
const cookieOpts = (extra = {}) => {
  const base = { path: COOKIE_PATH, ...extra }
  // IP/localhost 访问时不设 domain，避免浏览器因域名不匹配丢弃 cookie
  if (COOKIE_DOMAIN) {
    base.domain = COOKIE_DOMAIN
  }
  return base
}
 
 export function getToken() {
   return Cookies.get(TokenKey)
 }
 
 export function setToken(token, rememberMe = false) {
   if (rememberMe) {
     return Cookies.set(TokenKey, token, cookieOpts({ expires: 7 }))
   } else {
     return Cookies.set(TokenKey, token, cookieOpts())
   }
 }
 
 export function removeToken() {
   return Cookies.remove(TokenKey, cookieOpts())
 }
 
 export function getUserId() {
   return Cookies.get(UserIdKey) || null
 }
 
 export function setUserId(userId, rememberMe = false) {
   if (userId) {
     if (rememberMe) {
       Cookies.set(UserIdKey, String(userId), cookieOpts({ expires: 7 }))
     } else {
       Cookies.set(UserIdKey, String(userId), cookieOpts())
     }
   }
 }
 
 export function removeUserId() {
   return Cookies.remove(UserIdKey, cookieOpts())
 }
 
 // ✅【核心修复】只获取当前用户信息
 export function getUserInfo() {
   const userId = getUserId()
   if (!userId) return {}
 
   try {
     return JSON.parse(localStorage.getItem(`userInfo-${userId}`) || '{}')
   } catch (e) {
     return {}
   }
 }
 
 // ✅【核心修复】只保存当前用户
 export function setUserInfo(userInfo) {
   if (!userInfo || !userInfo.id) return
   localStorage.setItem(`userInfo-${userInfo.id}`, JSON.stringify(userInfo))
 }
 
 // 清除当前用户信息
 export function removeUserInfo() {
   const userId = getUserId()
   if (userId) localStorage.removeItem(`userInfo-${userId}`)
 }
 
 // 记住我 - 保存手机号
 export function setRememberPhone(phone) {
   if (phone) {
     localStorage.setItem(RememberPhoneKey, phone)
   }
 }
 
 // 记住我 - 获取保存的手机号
 export function getRememberPhone() {
   return localStorage.getItem(RememberPhoneKey) || ''
 }
 
// 记住我 - 清除保存的手机号
export function removeRememberPhone() {
  localStorage.removeItem(RememberPhoneKey)
}

// 记住密码 - 保存密码
export function setRememberPassword(phone, passwordEncoded) {
  if (phone && passwordEncoded) {
    localStorage.setItem(RememberPasswordKey + '-' + phone, passwordEncoded)
  }
}

// 记住密码 - 获取保存的密码
export function getRememberPassword(phone) {
  if (!phone) return ''
  return localStorage.getItem(RememberPasswordKey + '-' + phone) || ''
}

// 记住密码 - 清除保存的密码
export function removeRememberPassword(phone) {
  if (phone) {
    localStorage.removeItem(RememberPasswordKey + '-' + phone)
  }
}
 
// 登出
export function clearAuth() {
  removeToken()
  removeUserInfo()
  removeUserId()
  // 不删除记住的手机号和密码，保留给下次登录使用
}
 
 const MallTokenKey = 'digital-card-mall-token'

// 获取商城token
export function getMallToken() {
  return Cookies.get(MallTokenKey)
}

// 设置商城token
export function setMallToken(token) {
  if (token) {
    return Cookies.set(MallTokenKey, token, cookieOpts({ expires: 7 }))
  }
  return null
}

// 移除商城token
export function removeMallToken() {
  return Cookies.remove(MallTokenKey, cookieOpts())
}

// ====== shareId 相关 —— 推荐关系绑定 ======

/**
 * 保存「待绑定」的推荐人 share_id（捕获到访问链接里的 ?share_id=xxx 时调用）
 * 之后注册 / 登录成功后会自动用这个值去绑定
 */
export function setPendingShareId(shareId) {
  if (!shareId) return
  localStorage.setItem(PendingShareIdKey, shareId)
}

export function getPendingShareId() {
  return localStorage.getItem(PendingShareIdKey) || ''
}

/** 绑定成功后清除 */
export function removePendingShareId() {
  localStorage.removeItem(PendingShareIdKey)
}

/**
 * 缓存当前用户自己的 shareId（登录后从后端拉一次即可）
 */
export function setMyShareId(shareId) {
  if (!shareId) return
  localStorage.setItem(MyShareIdKey, shareId)
}

export function getMyShareId() {
  return localStorage.getItem(MyShareIdKey) || ''
}

export function removeMyShareId() {
  localStorage.removeItem(MyShareIdKey)
}
